import LoginPage from './loginPage';

const routes = [
    {path : 'login', component: () => <LoginPage/>, isPublic : true},
]

export default routes;